import React, { useEffect, useRef } from "react"
import { Helmet } from "react-helmet"
import graphql from "babel-plugin-relay/macro"

import ConversationHistory from "../../components/ConversationHistory/ConversationHistory"
import {
  useQueryLoader,
  usePreloadedQuery,
} from "react-relay"

import { LoadingMask } from "../../CommonStyles"
import { useOutletContext } from "react-router-dom"

const MessengerQuery = graphql`
  query MessengerQuery {
    customerViewer {
      id
      businessId
      orgId
      profile {
        name
        legalName
        about
        phones {
          number
          alias
        }
        emails {
          email
          alias
        }
        addresses {
          alias
          line1
          line2
          city
          state
          country
          zip
        }
        websites {
          url
          alias
        }
        logoUrl
        botAgentImageUrl
      }
      chatConfiguration {
        themeColor
        customCss
        showAgentProfile
        localised {
          localeId
          persistentMenu {
            buttons
            enable
          }
          iceBreakers {
            ctas
            enable
          }
        }
      }
      localeGroups {
        id
        name
        locales
        default
      }
    }
  }
`

const InnerMessenger = ({
  isRefreshing,
  queryRef,
  postMessageToSDK,
  ...props
}) => {
  const firstOpen = useRef(null)
  const data = usePreloadedQuery(
    MessengerQuery,
    queryRef,
  )

  const sendFirstOpenEvent = () => {
    if (!firstOpen.current) {
      postMessageToSDK({
        event: "FIRST_OPEN"
      })
      firstOpen.current = true
    }
  }

  const handleEvent = (e) => {
    if (e?.data?.source === "woztell-web-chat-parent") {
      const payload = e.data.payload
      switch (payload.event) {
        case "INIT": {
          const {
            defaultOpen = false,
          } = payload.data
          if (defaultOpen) {
            sendFirstOpenEvent()
          }
          break
        }
        case "OPEN_WEBCHAT":
          sendFirstOpenEvent()
          break
        default:
          break
      }
    }
  }

  useEffect(() => {
    postMessageToSDK({
      event: "MESSENGER_READY"
    })
    window.addEventListener("message", handleEvent)

    return () => {
      window.removeEventListener("message", handleEvent)
    }
  }, [])

  useEffect(() => {
    if (data?.customerViewer?.businessId) {
      postMessageToSDK({
        event: "BUSINESS_INFO_LOADED"
      })
    }
  }, [data?.customerViewer?.businessId])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{data?.customerViewer?.profile?.name || "Woztell Webchat"}</title>
      </Helmet>
      <ConversationHistory
        info={data}
        onPostMessageToSDK={(event) => {
          postMessageToSDK(event)
        }}
      />
    </>
  )
}

const Messenger = ({
  cookies,
  ...props
}) => {
  const {
    postMessageToSDK,
  } = useOutletContext()
  const [
    queryReference,
    loadQuery,
  ] = useQueryLoader(
    MessengerQuery,
    props.initialQueryRef, /* e.g. provided by router */
  )

  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      loadQuery()
    }
  }, [])

  if (queryReference) {
    return (
      <InnerMessenger
        queryRef={queryReference}
        postMessageToSDK={postMessageToSDK}
      />
    )
  }
  return (
    <LoadingMask>
      <div className="line"></div>
      <div className="line"></div>
      <div className="line"></div>
    </LoadingMask>
  )
}

export default Messenger
